import { Severity, type SpeedEvent } from '@cobliteam/common-types';
import { SeverityAPI, type SpeedEventAPI } from './Types';

const toSeverity = (severityAPI: SeverityAPI): Severity => {
  if (severityAPI === SeverityAPI.MEDIUM) {
    return Severity.MEDIUM;
  }

  if (severityAPI === SeverityAPI.HIGH) {
    return Severity.SEVERE;
  }

  return Severity.VERY_SEVERE;
};

export const toSeverityAPI = (severity: Severity): SeverityAPI => {
  if (severity === Severity.MEDIUM) {
    return SeverityAPI.MEDIUM;
  }

  if (severity === Severity.SEVERE) {
    return SeverityAPI.HIGH;
  }

  return SeverityAPI.HIGHER;
};

export const toCapitalSeverity = (severity: Severity): string => {
  return toSeverityAPI(severity).toUpperCase();
};

export const toSpeedEvent =
  (type: 'road' | 'vehicle') =>
  (responseAPI: SpeedEventAPI): SpeedEvent => ({
    eventTime: responseAPI.event_time,
    vehicleId: responseAPI.vehicle_id,
    groupId: responseAPI.group_id,
    deviceId: responseAPI.device_id,
    driverId: responseAPI.driver_id,
    location: responseAPI.location,
    speedInKmh: responseAPI.speed_in_kmh,
    speedLimitInKmh: responseAPI.speed_limit_in_kmh,
    durationAboveInMillis: responseAPI.duration_above_in_millis,
    severity: toSeverity(responseAPI.severity),
    startTime: responseAPI.start_time,
    medianSpeedInKmh: responseAPI.median_speed_in_kmh,
    medianBasedSeverity: responseAPI.median_based_severity && toSeverity(responseAPI.median_based_severity),
    type,
  });
